import NavBarPortal from "NavBar/NavBarPortal";

import Confetti from "./Confetti/Confetti";
import Drawer from "./Drawer";
import Modal from "./Modal";
import OverlayModal from "./OverlayModal";
import PeekHandle from "./PeekHandle";
import SquigglePortal from "./Squiggle/SquigglePortal";

const GlobalComponents = () => (
  <>
    {/* Add any components here that should always be rendered. */}
    <Modal />
    <OverlayModal />
    <Drawer />
    <NavBarPortal />
    <SquigglePortal />
    <PeekHandle />
    <Confetti />
  </>
);

export default GlobalComponents;
